module.exports = __webpack_public_path__ + "images/2e5c645d41c5d05ec0eff23c72c65db3-logo_white.png";